import $ from 'jquery';
jQuery.noConflict();

// Disable submit button on click - useful for form submits where the page refreshes
export function disableSubmitButton(divClass) {
    $(divClass).on("click", function(e){
        e.preventDefault();

        setTimeout(function() {
            let validationFailed = $('.validation-failed').length;
            // Make sure the validation doesnt fail 
            if (validationFailed == 0) {
                $(divClass).prop('disabled', true);  
                $(divClass).trigger('click');
            }
        }, 500);
    });
}